import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { AdminShell } from "../../components/AdminShell";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { toast } from "sonner";

export default function AdminFinance() {
  const [apps, setApps] = useState([]);
  const load = async () => {
    const { data } = await api.get("/finance-apps");
    setApps(data || []);
  };
  useEffect(() => { load(); }, []);

  const updateStatus = async (app, status) => {
    try {
      await api.put(`/finance-apps/${app.id}`, { ...app, status });
      toast.success(`Marked ${status}`);
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <AdminShell title="Finance Desk">
      <div className="surface rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="surface-elev text-left">
            <tr>
              <th className="px-4 py-3 label-eyebrow">App</th>
              <th className="px-4 py-3 label-eyebrow">Created</th>
              <th className="px-4 py-3 label-eyebrow">Requested</th>
              <th className="px-4 py-3 label-eyebrow">Monthly Income</th>
              <th className="px-4 py-3 label-eyebrow">Employer</th>
              <th className="px-4 py-3 label-eyebrow">BK</th>
              <th className="px-4 py-3 label-eyebrow">Status</th>
              <th className="px-4 py-3 label-eyebrow">Decision</th>
            </tr>
          </thead>
          <tbody>
            {apps.map((a) => (
              <tr key={a.id} className="border-t border-white/5 hover:bg-white/[0.02] transition-colors" data-testid={`finance-app-${a.id}`}>
                <td className="px-4 py-3 font-mono text-xs text-slate-300">{a.id.slice(0, 8)}</td>
                <td className="px-4 py-3 text-slate-400">{a.created_at?.slice(0, 10)}</td>
                <td className="px-4 py-3 gold-text font-semibold">${a.requested_amount?.toLocaleString()}</td>
                <td className="px-4 py-3">${a.monthly_income?.toLocaleString()}</td>
                <td className="px-4 py-3">{a.employer}</td>
                <td className="px-4 py-3">{a.bankruptcy_history ? <span className="pill pill-sold">Yes</span> : <span className="text-slate-500">—</span>}</td>
                <td className="px-4 py-3">
                  <span className={`pill ${
                    a.status === "approved" ? "pill-available" :
                    a.status === "denied" ? "pill-sold" :
                    a.status === "conditional" ? "pill-pending" : "pill-navy"
                  }`}>{a.status}</span>
                </td>
                <td className="px-4 py-3">
                  <Select value={a.status} onValueChange={(v) => updateStatus(a, v)}>
                    <SelectTrigger className="h-8 bg-[#04060d] border-white/10 text-xs w-32" data-testid={`finance-status-${a.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="pending">Pending</SelectItem>
                      <SelectItem value="approved">Approved</SelectItem>
                      <SelectItem value="conditional">Conditional</SelectItem>
                      <SelectItem value="denied">Denied</SelectItem>
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
            {apps.length === 0 && (
              <tr><td colSpan={8} className="px-4 py-12 text-center text-slate-500">No finance applications yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
}
